import { useRef } from "react";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import { useUserOptions } from "../../../hooks/useUserOptions";
import ThemeButton from "../../../components/ThemeButton/ThemeButton";
import { Avatar } from "primereact/avatar";
import { useAppSelector } from "../../../hooks/ReduxHooks";
import { Rootstate } from "../../../store/store";

const UserButton = () => {
  const menuRight = useRef<Menu>(null);
  const userOptions = useUserOptions();
  const { user } = useAppSelector((state: Rootstate) => state.auth);

  const options = [
    {
      label: "Perfil",
      items: userOptions,
    },
    {
      separator: true,
    },
    {
      template: () => <ThemeButton />,
    },
  ];

  return (
    <div className="hidden md:flex align-items-center">
      <Button
        type="button"
        onClick={(event) => menuRight.current?.toggle(event)}
        className="p-1 border-circle surface-border border-1 hover:shadow-2 transition-duration-200 bg-transparent flex align-items-center justify-content-center"
        rounded
        aria-controls="popup_menu_right"
        aria-haspopup
      >
        <Avatar
          image={
            user?.imageBase64
              ? `${user.imageFormat},${user.imageBase64}`
              : undefined
          }
          label={
            !user?.imageBase64 && !user?.imageBase64
              ? user?.firstName?.charAt(0).toUpperCase()
              : undefined
          }
          icon={
            !user?.imageBase64 && !user?.firstName ? "pi pi-user" : undefined
          }
          shape="circle"
          className="w-2rem h-2rem bg-primary-100 text-primary-700 font-bold"
        />
        <i className="pi pi-angle-down ml-2 text-color-secondary mr-1"></i>
      </Button>

      <Menu
        popup
        ref={menuRight}
        model={options}
        id="popup_menu_right"
        popupAlignment="right"
        className="mt-2 w-16rem"
      />
    </div>
  );
};

export default UserButton;
